import React, { createContext, useContext, useCallback, useState } from 'react';

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);

const icons = {
  success: <path d="M20 6L9 17l-5-5" />,
  error: <path d="M18 6L6 18M6 6l12 12" />,
  info: <path d="M12 16v-4M12 8h.01M12 22a10 10 0 100-20 10 10 0 000 20z" />,
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
  }, []);

  const push = useCallback((type, msg, ttl = 4500) => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, type, msg }]);
    setTimeout(() => dismiss(id), ttl);
  }, [dismiss]);

  const api = {
    success: (m) => push('success', m),
    error: (m) => push('error', m, 6000),
    info: (m) => push('info', m),
  };

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.type}`} onClick={() => dismiss(t.id)}>
            <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {icons[t.type]}
            </svg>
            <span>{t.msg}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

// turns raw wallet/contract errors into something human-readable
export function readableError(err) {
  if (!err) return 'Something went wrong';
  if (err.code === 4001 || err.code === 'ACTION_REJECTED') return 'Transaction rejected';
  const reason = err.reason || (err.error && err.error.message) || err.data?.message || err.message;
  if (!reason) return 'Transaction failed';
  // strip noisy prefixes
  return reason.replace('execution reverted:', '').replace('MetaMask Tx Signature:', '').trim();
}
